import { JobsTable } from "../components/Jobs/JobsTable";
import DocsHelpLink from "@/components/Docs/DocsHelpLink";

const JobsPage = () => {
  return (
    <div className="flex-1 min-h-0 flex flex-col">
      <div className="flex my-2 gap-2 flex-col sm:flex-row items-start sm:items-center flex-wrap justify-between shrink-0">
        <h2 className="text-3xl font-bold tracking-tight flex items-center gap-2">Jobs<DocsHelpLink to="administration/jobs" /></h2>
      </div>
      <JobsTable />
    </div>
  );
};

export default JobsPage;
